import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { AdminMission } from '../../models/mission-admin';
import { MissionAdminService } from '../../services/mission-admin.service';
import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';

@Component({
  selector: 'app-missions',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TableModule, AdminPageHeaderComponent],
  templateUrl: './missions.component.html',
  styleUrl: './missions.component.scss',
})
export class MissionsComponent implements OnInit {
  readonly title = 'Missões (Templates)';
  readonly subtitle = 'Gerencie os templates de missões da Gamers Brawl para todos os jogos.';

  missions: AdminMission[] = [];
  isLoading = false;
  
  searchTerm = '';
  gameFilter = '';
  statusFilter = '';
  feedbackError = '';

  totalMissions = 0;
  page = 1;
  rowsPerPage = 10;

  constructor(private missionService: MissionAdminService, private router: Router) {}

  ngOnInit(): void {
    this.fetchMissions();
  }

  fetchMissions(): void {
    this.isLoading = true;
    this.missionService
      .list({ 
        search: this.searchTerm.trim(), 
        game: this.gameFilter, 
        is_active: this.statusFilter,
        page: this.page
      })
      .subscribe({
        next: (response: any) => {
          this.missions = response?.results || response || [];
          this.totalMissions = response?.count || 0;
          this.isLoading = false;
          this.feedbackError = '';
        },
        error: (error) => {
          this.missions = [];
          this.totalMissions = 0;
          this.isLoading = false;
          this.feedbackError = this.extractErrorMessage(error, 'Não foi possível carregar as missões.');
        },
      });
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const first = event.first ?? 0;
    this.page = Math.floor(first / this.rowsPerPage) + 1;
    this.fetchMissions();
  }

  createMission(): void {
    this.router.navigate(['/dashboard/missions/nova']);
  }

  detailMission(missionId: number): void {
    this.router.navigate(['/dashboard/missions', missionId]);
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.gameFilter = '';
    this.statusFilter = '';
    this.page = 1;
    this.fetchMissions();
  }

  applyFilters(): void {
    this.page = 1;
    this.fetchMissions();
  }

  private extractErrorMessage(error: any, fallback: string): string {
    const response = error?.error;
    if (!response) return fallback;
    if (typeof response === 'string') return response;
    if (typeof response?.detail === 'string') return response.detail;
    return fallback;
  }
}